var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7V160l177.8 118.5a31.9 31.9 0 0 1 14.2 26.6v56.7a16 16 0 0 1-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42a14 14 0 0 1-17.9 13.5L256 480l-110.1 31.5A14 14 0 0 1 128 498v-42c0-5 2.4-9.8 6.4-12.8L192 400v-80L21.1 377A16 16 0 0 1 0 361.8v-56.7c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.2aaee09306c0b689199f61c3ca3f1048.svg";
export { ForwardRef as ReactComponent };